import { unsetSentryTagForUser } from './sentry-tag';

export function resetOnUnauthenticate() {
  unsetSentryTagForUser();
  localStorage.clear();
}
